declare const BOOTSTRAP_VERSION: number;
const _BOOTSTRAP_VERSION = BOOTSTRAP_VERSION || 2;
export {_BOOTSTRAP_VERSION as BOOTSTRAP_VERSION};

export const DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_DISPLAY = 'DD MMM YYYY';

export const API_HEADERS = new Headers({
	Accept: 'application/json',
	'Content-Type': 'application/json',
});

export const CREDENTIALS = 'same-origin';
